// Auto Europarts — clean brand logo (transparent PNG), lightly enhanced for dark backgrounds
// Import via webpack so the built asset gets a content-hash in its filename —
// this guarantees the CDN + browser cache always fetch the latest logo on redeploy.
import logoAsset from "@/assets/logo.png";
const LOGO_SRC = logoAsset;

// Subtle enhancement — vibrant colours with clean shadow
const SOFT_FILTER =
    "brightness(1.15) contrast(1.15) saturate(1.35) drop-shadow(0 10px 30px rgba(0,0,0,0.55))";

export default function Logo({ variant = "full", className = "" }) {
    if (variant === "compact") {
        return (
            <div className={`flex items-center ${className}`}>
                <img
                    src={LOGO_SRC}
                    alt="Auto Europarts — Car Dismantlers"
                    className="h-14 w-auto object-contain"
                    style={{ filter: SOFT_FILTER }}
                />
            </div>
        );
    }

    if (variant === "mark") {
        return (
            <div className={className}>
                <img
                    src={LOGO_SRC}
                    alt="Auto Europarts"
                    className="h-9 w-auto object-contain"
                    style={{ filter: SOFT_FILTER }}
                />
            </div>
        );
    }

    // full — smaller, more refined
    return (
        <div className={`inline-block ${className}`} data-testid="brand-logo">
            <img
                src={LOGO_SRC}
                alt="Auto Europarts — Used Car Parts — Car Dismantlers"
                className="w-full max-w-[640px] h-auto object-contain"
                style={{ filter: SOFT_FILTER }}
            />
        </div>
    );
}
